module.exports = __webpack_public_path__ + "static/media/Pet.fc146050.png";